'use client'

import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

// Nothing to show (the design system's .empty-state): a centred icon, a
// short title, one line of text, and at most one action.
export function EmptyState({ icon: Icon, title, children, action, className = '' }: { icon?: LucideIcon; title: ReactNode; children?: ReactNode; action?: ReactNode; className?: string }) {
  return (
    <div className={`flex flex-col items-center gap-2.5 px-4 py-11 text-center ${className}`}>
      {Icon && <Icon className="mb-1 h-6 w-6 text-subtle" strokeWidth={1.5} />}
      <h3 className="text-body font-medium text-foreground">{title}</h3>
      {children && <p className="max-w-md text-small text-muted-foreground">{children}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}

/** The loading line, in the same voice. */
export function LoadingState({ children = 'Loading…', className = '' }: { children?: ReactNode; className?: string }) {
  return <div className={`px-4 py-10 text-center font-mono text-small text-subtle ${className}`}><span className="animate-pulse">{children}</span></div>
}
